<time-picker>
  <select class="form-control-just tp-hour" name="hour" onchange="{ handleHourChange }" required="{ props.required }"
    disabled="{ props.disabled }">
    <option value="-1" selected disabled="{ props.required }"> -- </option>
    <option if="{ hasHiddenHour() }" value="{ getHoursValue() }" selected="{ true }" hidden>
      { getHiddenHourLabel() }
    </option>
    <option if="{ props.openClose }" value="-2" selected="{ getHoursValue() === -2 }">OPEN</option>
    <option each="{ select in createSelectHours(props.btStart, props.btEnd) }" value="{ select.value }"
      selected="{ getHoursValue() === select.value }">{ select.label }</option>
    <option if="{ props.openClose }" value="-3" selected="{ getHoursValue() === -3 }">LAST</option>
  </select>
  <select class="form-control-just tp-min" name="minute" onchange="{ handleMinuteChange }"
    disabled="{ isMinuteDisabled() }">
    <option if="{ hasHiddenMinute() }" value="{ getMinutesValue() }" selected="{ true }" hidden>
      { getHiddenMinuteLabel() }
    </option>
    <option each="{ select in createSelectMinutes(props.step) }" value="{ select.value }"
      selected="{ getMinutesValue() === select.value }">
      { props.step == 1 && select.value % 10 == 0 ? hanToZen(select.label) : select.label }
    </option>
  </select>
  <script>
    import { hanToZen } from '@/common/utils/strings';
    import { hourToReadableStr } from '@/common/utils/date';
    const createSelectMinutes = (step = 5) => {
      const minutes = [];
      const len = 60 / step;
      for (let i = 0; i < len; i++) {
        minutes.push({
          label: `${i * step}分`,
          value: i * step
        });
      }
      return minutes;
    };

    const createSelectHours = (btStart = 0, btEnd = 23 * 60) => {
      const hours = [];
      for (let i = Math.floor(btStart / 60); i <= Math.floor(btEnd / 60); i++) {
        hours.push({
          label: hourToReadableStr(i),
          value: i * 60
        });
      }
      return hours;
    };

    export default {
      hanToZen,
      createSelectHours,
      createSelectMinutes,
      hasHiddenHour() {
        const selectHours = createSelectHours(this.props.btStart, this.props.btEnd);
        return !(
          this.props.value == null
          || this.props.value == -1
          || this.props.value == -2
          || this.props.value == -3
          || selectHours.some(select => this.props.value - (this.props.value % 60) === select.value)
        );
      },

      getHiddenHourLabel() {
        const hour = (this.props.value - (this.props.value % 60)) / 60;
        return hourToReadableStr(hour);
      },

      hasHiddenMinute() {
        const selectMinutes = createSelectMinutes(this.propsstep);
        return !(
          this.props.value == null
          || this.props.value == -1
          || this.props.value == -2
          || this.props.value == -3
          || selectMinutes.some(select => this.props.value % 60 === select.value)
        );
      },

      getHiddenMinuteLabel() {
        return `${this.props.value % 60}分`;
      },

      getHoursValue() {
        if (this.props.openClose && (this.props.value == -2 || this.props.value == -3)) {
          return this.props.value;
        }
        if (this.props.value == -2) {
          return this.props.btStart - (this.props.btStart % 60);
        }
        if (this.props.value == -3) {
          return this.props.btEnd - (this.props.btEnd % 60);
        }
        return this.props.value - (this.props.value % 60);
      },

      getMinutesValue() {
        if (this.props.openClose && (this.props.value == -2 || this.props.value == -3)) {
          return -1;
        }
        if (this.props.value == -2) {
          return this.props.btStart % 60;
        }
        if (this.props.value == -3) {
          return this.props.btEnd % 60;
        }
        return this.props.value % 60;
      },

      isMinuteDisabled() {
        const h = this.props.openClose && (this.getHoursValue() == -2 || this.getHoursValue() == -3);
        return this.props.disabled || h;
      },

      handleHourChange(e) {
        const hour = Number(e.target.value);
        if (hour == -1 || hour == -2 || hour == -3) {
          typeof this.props.onChange === 'function' && this.props.onChange(hour);
          return;
        }
        const minute = this.props.value < 0 ? 0 : this.props.value % 60;
        typeof this.props.onChange === 'function' && this.props.onChange(hour + minute);
      },

      handleMinuteChange(e) {
        if (this.props.value == -1) {
          typeof this.props.onChange === 'function' && this.props.onChange(-1);
        }
        const hour = this.props.value - (this.props.value % 60);
        const minute = Number(e.target.value);
        typeof this.props.onChange === 'function' && this.props.onChange(hour + minute);
      }
    };
  </script>
  <style>
    .tp-hour {
      width: 77px;
    }

    .tp-min {
      width: 70px;
    }
  </style>
</time-picker>